import { FeedbackDialogParams, FeedbackCompoundCategory } from 'owa-feedback';
import loc from 'owa-localize';
import {
    feedbackFormTitleComposeAssistance,
    feedbackFormSubTitleComposeAssistance,
    feedbackFormGhostTextComposeAssistance,
    feedbackFormDonationTextComposeAssistance,
    feedbackFormDonationTooltipComposeAssistance,
    composeAssistanceCategory1,
    composeAssistanceCategory2,
    composeAssistanceCategory3,
    composeAssistanceCategory4,
    composeAssistanceCategory5,
} from '../plugin/SmartComposePlugin.locstring.json';
import { feedbackDialogOtherOption } from './suggestionInEditor.locstring.json';

// This object consists of the unlocalized English logstrings (strings for feedback logging) of the
// corresponding feedback options listed in "./SmartComposePlugin.locstring.json".
// The strings in this object should be in sync with the strings in "./SmartComposePlugin.locstring.json".
const COMPOSE_ASSISTANCE_LOGSTRING = {
    composeAssistanceCategory1: 'Not relevant',
    composeAssistanceCategory2: "Don't sound like me",
    composeAssistanceCategory3: 'Offensive or rude',
    composeAssistanceCategory4: "Didn't save me time",
    composeAssistanceCategory5: 'Too frequent',
    feedbackDialogOtherOption: 'Other',
};

export default function getNoFeedbackDialogParamsAssistanceCompose(
    chosenSuggestions: FeedbackCompoundCategory[],
    messageBody: string
): FeedbackDialogParams {
    return {
        subCategories: chosenSuggestions,
        categories: [
            {
                logString: COMPOSE_ASSISTANCE_LOGSTRING.composeAssistanceCategory1,
                uiString: loc(composeAssistanceCategory1), // in-sync with logString
            },
            {
                logString: COMPOSE_ASSISTANCE_LOGSTRING.composeAssistanceCategory2,
                uiString: loc(composeAssistanceCategory2), // in-sync with logString
            },
            {
                logString: COMPOSE_ASSISTANCE_LOGSTRING.composeAssistanceCategory3,
                uiString: loc(composeAssistanceCategory3), // in-sync with logString
            },
            {
                logString: COMPOSE_ASSISTANCE_LOGSTRING.composeAssistanceCategory4,
                uiString: loc(composeAssistanceCategory4), // in-sync with logString
            },
            {
                logString: COMPOSE_ASSISTANCE_LOGSTRING.composeAssistanceCategory5,
                uiString: loc(composeAssistanceCategory5), // in-sync with logString
            },
            {
                logString: COMPOSE_ASSISTANCE_LOGSTRING.feedbackDialogOtherOption,
                uiString: loc(feedbackDialogOtherOption), // in-sync with logString
            },
        ],
        title: loc(feedbackFormTitleComposeAssistance),
        subTitle: loc(feedbackFormSubTitleComposeAssistance),
        ghostText: loc(feedbackFormGhostTextComposeAssistance),
        donationText: loc(feedbackFormDonationTextComposeAssistance),
        donationToolTip: loc(feedbackFormDonationTooltipComposeAssistance),
        donationJson: {
            messageBody: messageBody,
        },
        submitCallBack: undefined,
        cancelCallBack: undefined,
        createUVTicket: false,
    };
}
